import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {Button, CustomComponent, Link} from '../components';
import {Icon} from './Icon';
import dialog from '../../common/dialog';
import {window} from '../util';

import './Banner.scss';


class BaseBanner extends CustomComponent {
    className: string;
    storeCloseState: boolean;
    closeOnResetTS: number;
    storageServiceKey: string;

    constructor(props: jsx.Props, context: jsx.AppGlobals, className: string,
        storeCloseState: boolean, closeOnResetTS: number) {
        super(props, context);
        this.className = className;
        this.storeCloseState = storeCloseState;
        this.closeOnResetTS = closeOnResetTS;
        this.storageServiceKey = `${this.className}.closedOn`;
        let closedOn = null;
        if (this.storeCloseState) {
            const storedVal = this.context.storageService.getItem(
                this.storageServiceKey);
            if (storedVal) {
                closedOn = parseInt(storedVal);
            }
        }
        this.state = {
            ...this.state,
            closedOn,
        };
    }
    registerEvent(eventName: string) {
        this.context.apiService.registerEvent(eventName);
    }
    @autobind
    closeHandler() {
        const closedOn = Date.now();
        this.setState({closedOn});
        this.storeCloseState && this.context.storageService.setItem(
            this.storageServiceKey, closedOn);

        window.gaEvent({
            category: this.className,
            action: 'close',
        });
    }
    isClosed() {
        const closedOn = this.state.closedOn;
        if (closedOn && closedOn > this.closeOnResetTS) {
            return true;
        }
        return false;
    }
}


export class LanguageBanner extends BaseBanner {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context, 'LanguageBanner', true, Date.UTC(1970, 1, 1));
    }
    bannerCopy() {
        const gettextSub = this.context.gtService.gettextSub;
        const gettextSubComponent = this.context.gtService.gettextSubComponent;

        const langLink =
            <span className="linkElements">
                <Button
                    onClick={() => {
                        dialog.open('language-selection-dialog');
                    }}
                >{gettextSub('here')}</Button>
            </span>;

        const generalCopy = <div>
            {
                // Translators: langLink is a button with the text "here".
                gettextSubComponent(
                    // eslint-disable-next-line max-len
                    `Tenor.com has been translated based on your browser's language setting. If you want to change the language, click {langLink}.`,
                    {langLink},
                )}
        </div>;

        return generalCopy;
    }
    render() {
        const hidden = !process.env.BROWSER || this.isClosed();
        return <div className={`Banner ${this.className}${hidden ? ' hidden' : ''}`}>
            <div className="container">
                <Icon name="remove" onClick={this.closeHandler}/>
                { this.bannerCopy() }
            </div>
        </div>;
    }
}


export class TOSBanner extends BaseBanner {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context, 'TOSBanner', true, Date.UTC(2024, 9, 30));
    }
    @autobind
    closeHandler() {
        super.closeHandler();

        this.registerEvent('tos_close');
    }
    render() {
        const gettextSub = this.context.gtService.gettextSub;
        const gettextSubComponent = this.context.gtService.gettextSubComponent;
        const localizeUrlPath = this.context.gtService.localizeUrlPath;
        const localizeHlParam = this.context.gtService.localizeHlParam;

        const closedOn = this.state.closedOn;
        const isLoggedIn = this.context.authService?.isLoggedIn();
        // Don't show if rendering server-side, or if user already closed it, or
        // if the user is logged in.
        const hidden = !process.env.BROWSER || closedOn || isLoggedIn;
        if (process.env.BROWSER && !hidden) {
            this.registerEvent('tos_splash_screen');
        }
        return <div className={`Banner ${this.className}${hidden ? ' hidden' : ''}`}>
            <div className="container">
                <Icon name="remove" onClick={this.closeHandler}/>
                {gettextSubComponent('We\'ve updated our {linkElements}. By continuing you agree to Tenor\'s {linkElements}.', {
                    linkElements: <span className="linkElements">
                        <Link
                            to={localizeUrlPath('/legal-terms')}
                            external={true}
                            onClick={() => {
                                this.registerEvent('tos_linkout_tap');
                            }}
                        >{gettextSub('Terms of Service')}</Link>
                        {gettextSub(' and ')}
                        <Link
                            to={localizeHlParam(
                                this.context.GOOGLE_PP_URL)}
                            external={true}
                            onClick={() => {
                                this.registerEvent('tos_linkout_tap');
                            }}
                        >{gettextSub('Privacy Policy')}</Link>
                    </span>,
                },
                )}
            </div>
        </div>;
    }
}
